import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force direct scroll to top without any delay
    window.scrollTo(0, 0);
    // Also scroll the main content area in case of layout-specific scrolling
    const main = document.querySelector('main');
    if (main) main.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

